import APIService from 'services/APIService'

const api = APIService()

export const getHandoverReadiness = bpId =>
  api.get(`/building-passport/${bpId}/handover-readiness`)

export const getHandoverPack = bpId =>
  api.get(`/building-passport/${bpId}/handover-pack`)

export const exportHandoverPackPdf = bpId =>
  api.get(`/building-passport/${bpId}/handover-pack/export/pdf`, { responseType: 'blob' })
